import React from 'react';
import BookingsTile from './tiles/BookingsTile';
import GoogleAdsTile from './tiles/GoogleAdsTile';
import WebsiteAnalyticsTile from './tiles/WebsiteAnalyticsTile';
import VisitorIntelligenceTile from './tiles/VisitorIntelligenceTile';
import AiVisibilityTile from './tiles/AiVisibilityTile';
import ChatTile from './tiles/ChatTile';
import VoiceTile from './tiles/VoiceTile';

// Single source of truth for the tile grid. Order = display order.
// entitlementFlag → the boolean view.* prop from ViewContext.
// LiveTile → the entitled-state component (or null for features we haven't
//            wired KPIs for yet — those always render as upsell for now).
// pitch    → one-line description shown in the upsell state.
// icon     → shared between the live and upsell tiles.

const iconBookings = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
);
const iconGoogleAds = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);
const iconGA4 = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v17a1 1 0 001 1h17M8 17V9M13 17V5M18 17v-7" />
  </svg>
);
const iconVisitors = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);
const iconAim = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);
const iconEvents = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);
const iconRoutes = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
  </svg>
);
const iconCompetitors = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);
const iconChat = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);
const iconVoice = (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
  </svg>
);

export const FEATURE_CATALOG = [
  {
    key: 'showBookings',
    title: 'Booking Intelligence',
    color: 'blue',
    icon: iconBookings,
    LiveTile: BookingsTile,
    pitch: 'See booking sessions, conversion rates, revenue, and where guests drop off before booking.',
  },
  {
    key: 'showGoogleAds',
    title: 'Google Ads',
    color: 'red',
    icon: iconGoogleAds,
    LiveTile: GoogleAdsTile,
    pitch: 'Track ROAS, spend, campaigns, and which keywords actually drive bookings.',
  },
  {
    key: 'showGoogleAnalytics',
    title: 'Website Analytics',
    color: 'amber',
    icon: iconGA4,
    LiveTile: WebsiteAnalyticsTile,
    pitch: 'See traffic sources, page performance, and which channels drive engaged sessions.',
  },
  {
    key: 'showCdp',
    title: 'Visitor Intelligence',
    color: 'teal',
    icon: iconVisitors,
    LiveTile: VisitorIntelligenceTile,
    pitch: 'Identify anonymous visitors, track their full journey, and see who is about to book.',
  },
  {
    key: 'showAim',
    title: 'AI Visibility',
    color: 'purple',
    icon: iconAim,
    LiveTile: AiVisibilityTile,
    pitch: 'See how ChatGPT, Gemini, and Google AI describe your property to travelers.',
  },
  {
    key: 'showEventIntelligence',
    title: 'Events Intelligence',
    color: 'emerald',
    icon: iconEvents,
    LiveTile: null,
    pitch: 'Discover concerts, sports, and festivals near you that drive booking demand.',
  },
  {
    key: 'showRouteIntelligence',
    title: 'Route Intelligence',
    color: 'slate',
    icon: iconRoutes,
    LiveTile: null,
    pitch: 'Understand where guests drive from, corridor traffic, and trip economics.',
  },
  {
    key: 'showCompetitiveIntelligence',
    title: 'Competitive Intelligence',
    color: 'purple',
    icon: iconCompetitors,
    LiveTile: null,
    pitch: 'Benchmark your rates against local competitors and find revenue opportunities.',
  },
  {
    key: 'showChat',
    title: 'AI Chat',
    color: 'teal',
    icon: iconChat,
    LiveTile: ChatTile,
    pitch: 'Answer guest questions on your website 24/7 with an AI trained on your property.',
  },
  {
    key: 'showVoice',
    title: 'AI Voice',
    color: 'blue',
    icon: iconVoice,
    LiveTile: VoiceTile,
    pitch: 'Handle inbound guest calls automatically with an AI voice agent that never sleeps.',
  },
];
